import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../services/core/authentication.service';
import { AppService } from '../../services/app.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';
import { CollectionManagerService } from '../../services/core/collection-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfigService } from '../../services/core/config.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPortfolioPreviewComponent } from 'src/app/modals/modal-portfolio-preview/modal-portfolio-preview.component';
import { ModalPortfolioOverviewComponent } from 'src/app/modals/modal-portfolio-overview/modal-portfolio-overview.component';
import { ModalPortfolioFeedbackComponent } from 'src/app/modals/modal-portfolio-feedback/modal-portfolio-feedback.component';
import { ModalNameComponent } from 'src/app/modals/modal-name/modal-name.component';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
	sections: any = [];
	currentUser;
	item;
	errors: any = [];
	errormessage = false;
	successmessage = false;
	changepassword = false;
	passwordValid = false;
	password = '';
	errorPassword = false;
	studyLevels = [];
	chapterList: any = [];
	chapterIdToName: any = [];
	quizResults: any = [];
	portfolio: any = [];
	selectedChapter: any = "";
	currentTab = 'profile';
	baseUrl = '';
	SYSTEM_NAME;
	frontStyle = '';

	search = "";

	selectedModules = [];
	selectedSections = [];
	selectedClassrooms = [];
	openDropdowns = [];
	portfolioEnabled = false;

	unreadFeedbackCount: any = 0;

	constructor(
		public appService: AppService,
		public api: ApiConnectionService,
		public authenticationService: AuthenticationService,
		public collectionManager: CollectionManagerService,
		private configService: ConfigService,
		private ngxLoader: NgxUiLoaderService,
		private modalService: NgbModal
	) {
		let self = this;

		this.frontStyle = configService.get('front_style');
		this.portfolioEnabled = configService.get('portfolio_enabled');
		this.baseUrl = configService.get('front_url');
		self.studyLevels = this.configService.get('study_levels');

		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.item = {};
				self.item['name'] = data['name'];
				self.item['email'] = data['email'];

				self.item['role'] = data['role'];

				self.item['isExternal'] = data['isExternal'];

				self.item['studyLevel'] = data['studyLevel'];
				self.item['canSwitchStudyLevel'] = data['canSwitchStudyLevel'];
				self.item['organisationName'] = data['organisationName'];
				self.item['classrooms'] = data['classroomTexts'].join(', ');
			} else {
				self.item = false;
			}
		});
		self.appService.setDefaultAuthor();
		this.appService.setShowCheckRequestAlert();
		this.setPortfolioFeedbackListener();
	}

	setPortfolioFeedbackListener () {
		let self = this;
		self.appService.activitiesData.subscribe(data => {
			try {
				self.unreadFeedbackCount = data['activities']['unreadFeedbackCount'];
			} catch (e) {
				self.unreadFeedbackCount = 0;
			}
		});
	}

	canShowSearch(title: any) {
		if (this.search != "") {
			return (title).toLowerCase().includes(this.search.toLowerCase());
		} else {
			return true;
		}
	}

	closeDropdowns() {
		this.openDropdowns.forEach(element => {
			element.classList.remove("show");
		});
		this.openDropdowns = [];
	}

	clearFilters() {
		const inputs = document.querySelectorAll('#portfolioNav input[type="checkbox"]');
		inputs.forEach((input: HTMLFormElement) => {
			input.checked = false;
		});

		this.selectedModules = [];
		this.selectedSections = [];
		this.selectedClassrooms = [];
	}

	viewImage(base64) {
		const modal = this.modalService.open(ModalPortfolioPreviewComponent, {
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.imgBase64 = base64;
	}

	viewPortfolio(id, lessonTitle) {
		const modal = this.modalService.open(ModalPortfolioOverviewComponent, {
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.portfolioId = id;
		modal.componentInstance.lessonTitle = lessonTitle
	}

	viewPortfolioFeedback(item) {
		let id = item['id'];
		item['unreadFeedbackCount'] = 0;
		
		const modal = this.modalService.open(ModalPortfolioFeedbackComponent, {
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.portfolioId = id;
	}

	toggleHiddenSection(id) {
		if (this.selectedSections.includes(id)) {
			this.selectedSections.splice(this.selectedSections.indexOf(id), 1);
		} else {
			this.selectedSections.push(id);
		}
	}

	toggleHiddenModule(id) {
		if (this.selectedModules.includes(id)) {
			this.selectedModules.splice(this.selectedModules.indexOf(id), 1);
		} else {
			this.selectedModules.push(id);
		}
	}

	toggleHiddenClassroom(name) {
		if (this.selectedClassrooms.includes(name)) {
			this.selectedClassrooms.splice(this.selectedClassrooms.indexOf(name), 1);
		} else {
			this.selectedClassrooms.push(name);
		}
	}

	ngOnInit(): void {
		this.appService.navActive();
		this.appService.setPageDescription('');

		let self = this;

		this.ngxLoader.start();
		self.authenticationService.getCurrentUser().then(function (response) {
			self.ngxLoader.stop();
		});

		self.fetchQuizResults();

		self.appService.setDefaultMeta();

		this.SYSTEM_NAME = this.configService.get('system_name');

		this.appService.setPageTitle('Profiel');

		this.addEventListener()
	}

	toggle(event) {
		if (!event.classList.contains("show")) {
			setTimeout(() => {
				event.classList.add("show");
				this.openDropdowns.push(event);
			}, 20);
		}
	}

	fetchQuizResults() {
		let self = this;

		this.ngxLoader.start();
		this.api.read('users/quizResults').then((response) => {
			self.quizResults = response;
			self.ngxLoader.stop();
		});
	}

	downloadPDF(item) {
		this.printPDF(item,true);
	}
  
	cleanString(title) {
		return title
			.toLowerCase()                   
			.trim()                          
			.replace(/[^\w\s-]/g, '')       
			.replace(/\s+/g, '-')          
			.replace(/-+/g, '-');   
	}

	async printPDF(item, download = false) {
		let portfolioId = item.id;

		const form = document.createElement('form');
		form.target = 'portfolioPDF';
		form.method = 'POST';
		form.action = this.api.getBaseURL() + "/users/portfolioPdf/&base64=1";
	
		const nameInput = document.createElement('input');
		nameInput.type = 'text';
		nameInput.name = 'name';
		nameInput.placeholder = 'Naam Achternaam';
		nameInput.className = 'form-control';
		nameInput.value = "";
	
		const portfolioInput = document.createElement('input');
		portfolioInput.type = 'hidden';
		portfolioInput.name = 'portfolioItemIds';
		portfolioInput.value = portfolioId;
	
		form.appendChild(nameInput);
		form.appendChild(portfolioInput);
	
		document.body.appendChild(form);
	
		const formData = new FormData(form);
	
		document.body.removeChild(form);
	
		try {
			const response = await this.api.post('users/portfolioPdf/&base64=1',formData);
			const result = await response.text();

			const byteCharacters = atob(result);
			const byteNumbers = new Array(byteCharacters.length);
	
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}
	
			const byteArray = new Uint8Array(byteNumbers);
			const blob = new Blob([byteArray], { type: 'application/pdf' });
			const blobURL = URL.createObjectURL(blob);
	
			const pdfObject: any = document.querySelector('#portfolioPDFObject');
			pdfObject.src = blobURL;

			if (download === true) {
				let name = 	this.cleanString(item.sectionTitle) + '-' + 
							this.cleanString(item.chapterTitle) + '-' + 
							this.cleanString(item.lessonTitle)
							;
				const date = new Date();
			  
				const day = String(date.getDate()).padStart(2, '0');
				const month = String(date.getMonth() + 1).padStart(2, '0'); 
				const year = date.getFullYear();
			
				const dateString = `${day}-${month}-${year}`;
		  
				const link = document.createElement('a');
				link.href = blobURL;
				link.download = 'portfolio-' + name + '-' + dateString + '.pdf';
				document.body.appendChild(link);
				
				link.click();
		  
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobURL);
				return;
			  }
	
			pdfObject.onload = () => {
				let printIFrame = document.getElementById('portfolioPDFObject');
	
				if (printIFrame instanceof HTMLIFrameElement) {
					printIFrame.contentWindow.focus();
					printIFrame.contentWindow.print();
				}
			};
		} catch (error) {
			console.error('Error fetching PDF:', error);
		}
	}
	
	fetchPortfolio() {
		let self = this;

		this.ngxLoader.start();
		this.api.read('users/portfolio').then((response) => {
			self.portfolio = response;
			self.portfolio.loaded = true;

			self.portfolio.items = self.sortPortfolio(true);

			self.ngxLoader.stop()
		});
	}

	sortEvent(e) {
		this.portfolio.items = this.sortPortfolio(e.target.value == 'true' ? true : false);
	}

	constructPortfolio(checkboxItemID = null) {
		if (checkboxItemID) {
			const select:HTMLInputElement = document.querySelector('[value="' + checkboxItemID + '"]');
			select.checked = !select.checked;
		}
		const configurePortfolioButton: HTMLInputElement = document.querySelector('.portfolioCol .form-group button.btn')

		const selectedPortfolioCards = document.querySelectorAll('.portfolioContent .card .portfolioCheck:checked')
		if (selectedPortfolioCards.length > 0) {
			configurePortfolioButton.disabled = false
			configurePortfolioButton.classList.add('active')
		} else {
			configurePortfolioButton.disabled = true
			configurePortfolioButton.classList.remove('active')
		}
	}

	formatDate(datetimeStr) {
		const months = ["januari", "februari", "maart", "april", "mei", "juni",
			"juli", "augustus", "september", "oktober", "november", "december"];

		const dateObj = new Date(datetimeStr);

		const day = dateObj.getDate();
		const monthIndex = dateObj.getMonth();
		const year = dateObj.getFullYear();

		const formattedDate = `${day} ${months[monthIndex]} ${year}`;

		return formattedDate;
	}

	sortPortfolio(ascending) {
		return this.portfolio.items.sort((a, b) => {
			const dateA: any = a.updatedAt;
			const dateB: any = b.updatedAt;

			if (!ascending) {
				if (dateA < dateB) {
					return -1
				} else {
					return 1
				}
			} else {
				if (dateA < dateB) {
					return 1
				} else {
					return -1
				}
			}
		});
	}

	selectChapter(key: any) {
		this.selectedChapter = key;
	}

	save() {
		let self = this;
		self.errors = [];
		self.successmessage = false;
		self.errormessage = false;

		self.item.changepassword = this.changepassword;

		let item = JSON.parse(JSON.stringify(self.item));

		if (typeof (item['adminpassword']) === 'undefined') {

		} else {
			item['adminpassword'] = encodeURIComponent(item['adminpassword']);
		}

		if (typeof (item['repeatpassword']) === 'undefined') {

		} else {
			item['repeatpassword'] = encodeURIComponent(item['repeatpassword']);
		}

		if (typeof (item['newpassword']) === 'undefined') {

		} else {
			item['newpassword'] = encodeURIComponent(item['newpassword']);
		}

		this.api.save('users/saveProfile', item).then((response) => {
			(window as any).scroll({
				top: 200,
				left: 0,
				behavior: 'smooth'
			});

			self.ngxLoader.stop();
			self.successmessage = true;
			self.changepassword = false;
			self.item.changepassword = false;

			self.item['adminpassword'] = null;
			self.item['newpassword'] = '';
			self.item['repeatpassword'] = '';

			self.passwordValid = false;
			self.password = '';
			self.errorPassword = false;

		}).catch(function (response) {
			self.errormessage = true;
			for (let error in response['error']['errors']) {
				self.errors[error] = response['error']['errors'][error];
			}
		});
	}

	checkChangepassword(event) {
		if (this.changepassword === true) {
			this.changepassword = false;
		} else {
			this.changepassword = true;
		}
	}

	checkPassword(event) {
		if (event.length < 4) {
			this.passwordValid = false;
			this.errorPassword = true;
		} else {
			this.passwordValid = true;
			this.errorPassword = false;
		}
	}

	setTab(tabName) {
		this.currentTab = tabName;

		if (this.currentTab == 'portfolio') {
			this.fetchPortfolio();
		}
	}

	addEventListener() {
		let scrollTop
		document.addEventListener('scroll', (event) => {
			const stickyPortfolioButton: HTMLElement = document.querySelector('button.configure-portfolio.active')
			if (!stickyPortfolioButton) {
				return
			}
			const stickyPortfolioButtonTop = stickyPortfolioButton.getBoundingClientRect().top
			const marginTop = 20

			if (window.scrollY < scrollTop) {
				stickyPortfolioButton.classList.remove('fixed-scroll')
			} else if (stickyPortfolioButtonTop < marginTop) {
				stickyPortfolioButton.classList.add('fixed-scroll')
				if (!scrollTop) scrollTop = window.scrollY
			}
		})
	}

	openConfigurePortfolioModal() {
		let portfolioIds = []
		const checkedPortfolios = document.querySelectorAll('.portfolioContent .portfolioCheck:checked')
		checkedPortfolios.forEach((portfolio: HTMLInputElement) => {
			portfolioIds.push(portfolio.value)
		})

		const url = this.api.getBaseURL() + '/users/portfolioPdf/'

		const modal = this.modalService.open(ModalNameComponent, {
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.portfolioIds = portfolioIds;
	}
}
